module.exports = [
  require('./concat.transform'),
  require('./filter.transform'),
  require('./forEach.transform'),
  require('./index.transform'),
  require('./map.transform'),
  require('./max.transform'),
  require('./mean.transform'),
  require('./min.transform'),
  require('./range.transform'),
  require('./subset.transform')
];



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/transform/index.js
// module id = 1217
// module chunks = 0